export const environment = {
    production: false, //true false
    //prod (true)
    NODE_ENV_PROD: 'production',
    APP_URL_PROD: 'https://healthsystem-mod.numedapp.com/',
    API_ENDPOINT_PROD: 'https://api-smarthealth.mod.go.th/api-healthsystem',
    API_TOKEN_PROD: 'b$?6b9qj94IZ0PjME?*K/7$qKpZ$fa3Ecm0bf?Uj/7fmdI*NP^!n2x&DWICT/?us',

    //uat (false)
    NODE_ENV: 'staging',
    APP_URL: 'https://healthsystem-mod-uat.numedapp.com/',
    API_ENDPOINT: 'https://api-smarthealth.mod.go.th/api-healthsystem-uat',
    API_TOKEN: 'HG12Jn3R&jjVsfxjYzW&a!Kpf?G1y5cMi809SFm9SINQU5l?IT81vE5i8!X$2E2t',
}

export const keys = {
    access_token: "AccessToken",
    refresh_token: "RefreshToken"
}

export const platform_name = 'mod-healthsystem-dashboard'

export const config = {
    NODE_ENV: process.env.REACT_APP_NODE_ENV,
    APP_URL: process.env.REACT_APP_APP_URL,
    API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
    ORIGIN: process.env.REACT_APP_APP_ORIGIN,
    STORAGE_ENDPOINT: process.env.REACT_APP_API_STORAGE,
    DOCUMENT_ENDPOINT: process.env.REACT_APP_DOCUMENT_ENDPOINT,
    API_TOKEN: process.env.REACT_APP_API_TOKEN,

}
